import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import PanesHeader from 'modules/core/components/PanesHeader'
import i18n from 'modules/core/lib/i18n'

import PlanPanel from 'modules/billing/components/PlanPanel'
import getPlanLabel from 'modules/billing/lib/getPlanLabel'
import plans, {
  subscriptionPlanOrScheduledPlan,
  subscriptionPriceWithDiscount,
} from 'modules/billing/store/collections/plans'
import subscriptions from 'modules/billing/store/collections/subscriptions'

const getIntervalsLabel = (type: string) => {
  switch (type) {
    case 'month':
      return i18n.t('billing.intervals.month')
    case 'year':
      return i18n.t('billing.intervals.year')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  onCTAClick: () => void | Promise<void>
  isUpgradeButtonVisible: boolean
}

const YourLegacyPlan = ({ onCTAClick }: Props) => {
  const subscription = subscriptions.current
  const plan = plans.current
  const planLabel = getPlanLabel(plan.type)
  const interval = subscription.scheduledInterval || plan.interval
  const intervalLabel = getIntervalsLabel(interval ?? '')
  const price = React.useRef<number>(subscriptionPriceWithDiscount(subscription)).current
  const incomingInvoice = subscription.attributes.incoming_invoice
  const amount = (incomingInvoice.total - incomingInvoice.tax) / 100

  if (!plan.isLegacy) return null

  return (
    <Box>
      <div>
        <PanesHeader
          illustration="multiple-buildings"
          title={i18n.t('billing.your_plan.title')}
          description={i18n.t('billing.your_plan.description')}
        />
        <Box paddingBottom="s32">
          <HelpCenterLink name="subscription_payments">
            {i18n.t('billing.your_plan.helpcenter_link')}
          </HelpCenterLink>
        </Box>
        <Button type="primary" onClick={onCTAClick}>
          {i18n.t('pricing_plans.upgrade_plan')}
        </Button>
      </div>
      <PlanPanel.Container
        title={i18n.t('billing.payment.plan_title', {
          plan: planLabel,
        })}
      >
        <PlanPanel.Row label={i18n.t('billing.bill.period')}>{intervalLabel}</PlanPanel.Row>
        <PlanPanel.Row label={i18n.t('billing.bill.price_per_employee')}>
          {i18n.t('billing.bill.per_month', {
            perMonth: subscriptionPlanOrScheduledPlan(subscription).priceWithCurrency(price),
          })}
        </PlanPanel.Row>
        <PlanPanel.Row label={i18n.t('billing.bill.employees_created')}>
          {subscription.attributes.current_cycle_quantity_on_payment_gateway}
        </PlanPanel.Row>
        <PlanPanel.Row label={i18n.t('billing.bill.next_payment')}>
          {plan.priceWithCurrency(amount)}
        </PlanPanel.Row>
      </PlanPanel.Container>
    </Box>
  )
}

export default YourLegacyPlan
